import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import "../CSS/ServiceCard.css";

const ServiceCard = ({ icon, title, description, type, onClick }) => {
  if (type === "button") {
    return (
      <div
        className="service-card call-to-action"
        onClick={() => window.location.href = "/signup"}
      >
        <span>{title}</span>
      </div>
    );
  }

  return (
    <div className="service-card" onClick={() => onClick(title)}>
      <div className="icon">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
      <div className="arrow">→</div>
    </div>
  );
};

const Services = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const [formData, setFormData] = useState({ name: "", phone: "", email: "", query: "" });
  const [alert, setAlert] = useState({ show: false, message: "", variant: "" });

  const services = [
    {
      title: "Mutual Funds",
      description: "Facilitating investments in various mutual fund schemes.",
      icon: "📊",
    },
    {
      title: "Portfolio Management Services",
      description: "Personalized investment management for HNIs.",
      icon: "📁",
    },
    {
      title: "Alternative Investment Funds",
      description: "Access to exclusive alternative investment opportunities.",
      icon: "📈",
    },
    {
      title: "Insurance",
      description: "Providing various insurance products.",
      icon: "🛡️",
    },
    {
      title: "Unlisted Shares",
      description: "Investments in unlisted companies.",
      icon: "📉",
    },
    {
      title: "Get Started Now",
      type: "button",
    },
  ];

  const handleCardClick = (serviceTitle) => {
    setSelectedService(serviceTitle);
    setShowForm(true);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbwEMCKvlPoPZ39BpCALq7pq224J90mS9uTyEbJ5MmcKp59pZf9XSOqyPqgzBk_vEkg/exec", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          service: selectedService,
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          query: formData.query,
        }),
      });

      const result = await response.text();


      if (result === "Success") {
        setAlert({ show: true, message: "Form submitted successfully!", variant: "success" });
      } else {
        setAlert({ show: true, message: "Submission error: " + result, variant: "danger" });
      }
    } catch (error) {
      setAlert({ show: true, message: "Failed to submit: " + error.message, variant: "danger" });
    }
  

    setShowForm(false);
    setFormData({ name: "", phone: "", email: "", query: "" });

    // Hide alert after 3 seconds
  setTimeout(() => {
    setAlert({ show: false, message: "", variant: "" });
  }, 3000);
  };

  return (
    <div className="services-container position-relative">
      {alert.show && (
        <Alert
          variant={alert.variant}
          className="position-fixed top-0 start-50 translate-middle-x mt-3 z-3 w-50 text-center"
        >
          {alert.message}
        </Alert>
      )}
      <h2>Online Services at ValueFundz</h2>
      <p className="subtext">
        ValueFundz offers an easy & simple online platform to invest in mutual
        funds, SIPs, debt funds & many more services.
      </p>
      <div className="services-grid">
        {services.map((service, index) => (
          <ServiceCard key={index} {...service} onClick={handleCardClick} />
        ))}
      </div>

      {showForm && (
        <div className="popup-form-overlay">
          <div className="popup-form">
            <button className="close-btn" onClick={() => setShowForm(false)}>×</button>
            <h3>Enquiry for {selectedService}</h3>
            <form onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Name" required onChange={handleChange} />
              <input type="text" name="phone" placeholder="Phone Number" required onChange={handleChange} />
              <input type="email" name="email" placeholder="Email" required onChange={handleChange} />
              <textarea name="query" placeholder="Your Query" rows="4" onChange={handleChange}></textarea>
              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      )}
      {alert.show && (
        <Alert variant={alert.variant} className="position-fixed w-50 text-center start-50 translate-middle-x bottom-0 mb-4 z-3">
          {alert.message}
        </Alert>
      )}
    </div>
  );
};

export default Services;
